export default __webpack_public_path__ + "static/media/globe.1bd1cb38.png";